import { JoinRegisterForm } from "./JoinRegisterForm";

interface JoinFormSectionProps {
  slug: string;
}

/**
 * Default (legacy) join layout'unun kayıt bölümü — yalnız bölüm kabuğu.
 * Formun kendisi `JoinRegisterForm`; temalar da aynı bileşeni `formSlot` ile
 * render eder, böylece görünüm farklı olsa da giden istek tek yerden gider.
 */
export function JoinFormSection({ slug }: JoinFormSectionProps) {
  return (
    <section className="min-h-screen bg-[#f7f7f7] px-6 py-24">
      <div className="mx-auto max-w-sm">
        <div className="mb-12 text-center">
          <h2
            className="font-serif text-4xl font-bold text-[#1b1817] sm:text-5xl"
            style={{ fontFamily: "var(--font-serif, 'Playfair Display', serif)" }}
          >
            Aramıza Katıl
          </h2>
          <p className="mt-4 text-base text-[#1b1817]/60">
            Daveti kabul etmek için adın ve telefon numaran yeterli.
          </p>
        </div>

        <JoinRegisterForm slug={slug} variant="light" />
      </div>
    </section>
  );
}
